import React from 'react'

import tinycolor from 'tinycolor2'

import Tooltip from '../../ui/Tooltip'
import ArrowBackIcon from '../../ui/icons/ArrowBack'
import ContentCopyIcon from '../../ui/icons/ContentCopy'
import KeyboardDoubleArrowDownIcon from '../../ui/icons/KeyboardDoubleArrowDown'
import KeyboardDoubleArrowUpIcon from '../../ui/icons/KeyboardDoubleArrowUp'
import LoopIcon from '../../ui/icons/Loop'

const SMALL_ICON_BUTTON_SIZE = 24

const PadOptionsIndicator: React.FC<{
  alwaysPlayFromStart: boolean
  loop: boolean
  multishot: boolean
  autoFadeInDuration: boolean
  fadeOutDuration: boolean
  color: string
}> = ({
  alwaysPlayFromStart,
  loop,
  multishot,
  autoFadeInDuration,
  fadeOutDuration,
  color,
}) => {
  const render = Boolean(
    alwaysPlayFromStart ||
      loop ||
      multishot ||
      fadeOutDuration ||
      autoFadeInDuration,
  )

  if (!render) return

  const textColor = tinycolor
    .mostReadable(color, ['#333', '#fff'])
    .toHexString()

  const bigIcon = {
    color: textColor,
    height: SMALL_ICON_BUTTON_SIZE - 6,
    width: SMALL_ICON_BUTTON_SIZE - 6,
  }
  const smallIcon = {
    color: textColor,
    height: SMALL_ICON_BUTTON_SIZE - 8,
    width: SMALL_ICON_BUTTON_SIZE - 8,
  }

  return (
    <div
      className="flex h-6 cursor-pointer items-center justify-center rounded-[0.2rem] px-1"
      style={{
        border: `1px solid ${color}`,
        backgroundColor: color,
      }}
    >
      <div className="flex flex-row flex-nowrap items-center">
        {alwaysPlayFromStart && (
          <Tooltip title="Play from start on trigger" placement="top">
            <ArrowBackIcon className="mb-0.5" style={bigIcon} />
          </Tooltip>
        )}

        {loop && (
          <Tooltip title="Loop enabled" placement="top">
            <LoopIcon className="mb-0.5" style={bigIcon} />
          </Tooltip>
        )}

        {multishot && (
          <Tooltip title="Multi-fire enabled" placement="top">
            <ContentCopyIcon className="mb-0.5" style={smallIcon} />
          </Tooltip>
        )}

        {Boolean(autoFadeInDuration) && (
          <Tooltip
            title={`Auto fade-in enabled (${autoFadeInDuration}s)`}
            placement="top"
          >
            <KeyboardDoubleArrowUpIcon className="mb-0.5" style={smallIcon} />
          </Tooltip>
        )}

        {Boolean(fadeOutDuration) && (
          <Tooltip
            title={`Auto fade-out enabled (${fadeOutDuration}s)`}
            placement="top"
          >
            <KeyboardDoubleArrowDownIcon className="mb-0.5" style={smallIcon} />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default PadOptionsIndicator
